// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {isArray, cloneDeep, noop} from 'lodash';

// PrimeReact UI components
import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';
import {Dialog} from 'primereact/dialog';

// Components
import Tag from './tag';

// Styles
import './tag.scss';

export default class TagList extends Component {
    state = {
        deleteDialogVisible: false,
        tagToDelete: undefined,
        tags: this.props.values,
    };

    getClass() {
        const {className} = this.props;

        return classnames(
            {
                tag: true,
            },
            className
        );
    }

    getTagProps() {
        return {
            handleDeleteClick: this.handleDeleteClick,
        };
    }

    handleDeleteClick = id => {
        this.setState({deleteDialogVisible: true, tagToDelete: id});
    };

    handleAddTag = () => {
        const {buildCustomTag, handleUpdateTag, id, options} = this.props;
        const {tags, dropDownSelection} = this.state;

        const tagArr = [...tags];

        const idx = options.findIndex(x => x.value === dropDownSelection);

        let tagEntry;
        if (buildCustomTag) {
            tagEntry = buildCustomTag(options[idx].label, options[idx].value, options[idx].category);
        } else {
            tagEntry = options[idx].value; // was label
        }

        tagArr.push(tagEntry);
        handleUpdateTag(tagArr, id);

        this.setState({tags: tagArr});
    };

    handleDeleteTag = () => {
        const {handleUpdateTag, id} = this.props;
        const {tags, tagToDelete} = this.state;

        const tagArr = tags.filter((_tag, index) => index !== tagToDelete);

        handleUpdateTag(tagArr, id);

        this.setState({deleteDialogVisible: false, tags: tagArr});
    };

    onDeleteDialogHide = () => {
        this.setState({deleteDialogVisible: false});
    };

    handleDropDownChange = e => {
        this.setState({dropDownSelection: e.target.value});
    };

    renderDialogHeader = (tags, tagToDelete, filterPlaceholder) => {
        if (tags != null && tagToDelete != null && tags[tagToDelete] != null) {
            if (isArray(tags)) {
                if (tags[tagToDelete].category) {
                    return `Delete ${tags[tagToDelete].category} ?`;
                }

                return `Delete ${filterPlaceholder} ?`;
            }
        }
    };

    renderDialogContent = (tags, tagToDelete) => {
        const {renderCustomTag} = this.props;
        if (tags != null && tagToDelete != null) {
            if (isArray(tags)) {
                if (renderCustomTag && tags[tagToDelete] != null) {
                    return renderCustomTag(tags[tagToDelete]);
                }

                return <p>{tags[tagToDelete]}</p>;
            }
        }
    };

    render() {
        const {options, filter, filterBy, filterPlaceholder, renderCustomTag} = this.props;
        const {tags, dropDownSelection, deleteDialogVisible, tagToDelete} = this.state;
        const enabledTags = [];

        const footer = (
            <div>
                <Button className="p-button-danger" icon="pi pi-check" label="DELETE" onClick={this.handleDeleteTag} />
                <Button icon="pi pi-times" label="No" onClick={this.onDeleteDialogHide} />
            </div>
        );

        tags.map((_val, idx) => {
            enabledTags.push(
                <Tag id={idx} {...this.getTagProps()}>
                    {renderCustomTag ? renderCustomTag(tags[idx]) : tags[idx]}
                </Tag>
            );
        });

        return (
            <div>
                <Dropdown
                    filter={filter}
                    filterBy={filterBy}
                    filterPlaceholder={`Search for ${filterPlaceholder}`}
                    options={options}
                    placeholder={`Select a ${filterPlaceholder}`}
                    showClear={false}
                    style={{leftMargin: '1em', margin: '5px', width: '300px'}}
                    value={dropDownSelection}
                    onChange={this.handleDropDownChange}
                />
                <Button icon="pi pi-plus" label={`Add ${filterPlaceholder}`} onClick={this.handleAddTag} />
                <br />
                {enabledTags}

                <Dialog
                    footer={footer}
                    header={this.renderDialogHeader(tags, tagToDelete, filterPlaceholder)}
                    modal={true}
                    style={{width: '50vmin'}}
                    visible={deleteDialogVisible}
                    onHide={this.onDeleteDialogHide}
                >
                    <br />
                    <br />
                    {this.renderDialogContent(tags, tagToDelete)}
                </Dialog>
            </div>
        );
    }
}

TagList.propTypes = {
    buildCustomTag: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    filter: PropTypes.bool,
    filterBy: PropTypes.string,
    filterPlaceholder: PropTypes.string,
    handleUpdateTag: PropTypes.func.isRequired,
    iconClassName: PropTypes.string,
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    options: PropTypes.object,
    renderCustomTag: PropTypes.func,
    style: PropTypes.object,
    title: PropTypes.string,
    type: PropTypes.string,
    values: PropTypes.array,
};

TagList.defaultProps = {
    onClick: noop,
};
